import React, { ReactNode, ReactElement } from 'react';
import { connect } from 'react-redux';
import { getEntityOfTypeOrThrow, maybeGetEntityOfType } from 'app/models/entities/selectors';
import { Entity, EntityStringId, IEntityType, IIdentifiableEntity } from '../../types/entity';
import { AppState } from 'app/store';

interface IBaseProps<T extends IIdentifiableEntity> {
  type: IEntityType<T>;
}

interface IProps<T extends IIdentifiableEntity> extends IBaseProps<T> {
  children: (params: Entity<T>) => ReactNode;
  id: EntityStringId;
}

interface INullableProps<T extends IIdentifiableEntity> extends IBaseProps<T> {
  children: (params: Entity<T> | null) => ReactNode;
  // Allow undefined and false to make MaybeGetEntity easier to use with && chains
  id: T['attributes']['id'] | null | undefined | false;
}

const GetEntityRender = <T extends IIdentifiableEntity>({ children, value }: {
  children: (params: Entity<T> | null) => ReactNode,
  value: Entity<T> | null,
}) => (
  <>{children(value)}</>
);

export const MaybeGetEntity = connect((state: AppState, { id, type }: INullableProps<IIdentifiableEntity>) => ({
  // `MaybeGetEntity` allows the `id` to be false-y, but `maybeGetEntityOfType` does not.
  value: id ? maybeGetEntityOfType(state, type, id) : null,
}))(GetEntityRender) as (
  <T extends IIdentifiableEntity>(props: INullableProps<T>) => ReactElement | null
);
export default connect((state: AppState, { id, type }: IProps<IIdentifiableEntity>) => ({
  value: getEntityOfTypeOrThrow(state, type, id),
}))(GetEntityRender) as (
  <T extends IIdentifiableEntity>(props: IProps<T>) => ReactElement | null
);
